// extracted by mini-css-extract-plugin
export var resizer = "_fq-0";